import { SET_CMSLIST } from '../actions';

const cmslist = (state = [], action) => {
  switch (action.type) {
	case SET_CMSLIST:
      return [...action.value];  
    default: return state;
  }
}

export default cmslist;
